import React, { useEffect, useState } from "react";
import axios from "axios";

const useDocument = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([]);
    const [content,setContent] = useState("")
    let mainApi = `/component/classify/type/document`;
    const getDocumentData = (params) => {
        //axios 開始前呼叫
        onBefore({
            axiosMode: "get",
        });
        return axios
            .get('/media_classification_storage/api/classify_structure_type/document', {
                params: params,
            })
            .then((response) => {
                let data = response.data;
                setData(data?.data);
                if (data) {
                    onFinish({
                        axiosMode: "get",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "get",
                        status: "error",
                    });
                }

                return {
                    ...data,
                };
            });
    };
    const postDocumentData = (data) => {
        onBefore({
            axiosMode: "post",
        });
        axios
            .post(mainApi, data)
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "success") {
                    onFinish({
                        axiosMode: "post",
                        status: "success",

                    });
                } else {
                    onFinish({
                        axiosMode: "post",
                        status: "error",
                    });

                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "post",
                    status: "error",
                });
            });
    };
    const patchDocumentData = (data) => {
        onBefore({
            axiosMode: "patch",
        });
        axios
            .patch(
                mainApi,
                data
            )
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "success") {

                    onFinish({
                        axiosMode: "patch",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "patch",
                        status: "error",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "patch",
                    status: "error",
                });
            });
    };
    const deleteDocumentData = (data) => {
        onBefore({
            axiosMode: "delete",
        });
        axios
            .delete(mainApi, {
                data,
            })
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "success") {
                    onFinish({
                        axiosMode: "delete",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "delete",
                        status: "error",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "delete",
                    status: "error",
                });
            });
    };
    const downloadDocumentData = (file_id ,file_client_name) => {
        onBefore({
            axiosMode: "get",
        });
        return axios
            .get('/media_classification_storage/api/classify_structure_type_file_download', {
                responseType: 'blob',
                params: {
                    file_id: file_id
                }
            })
            .then((response) => {
               
                const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', `${file_client_name}`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
    }
    const getDocumentFile = (file_id) => {
        return axios
            .get("/media_classification_storage/api/file/upload", {
                responseType: "blob",
                params: { file_id: file_id },
            })
            .then((response) => {
                var blob_ = new Blob([response.data], {
                    type: "image/png", // this is the only MIME for SVG
                });
                return response.data
                // console.log(blob_);
                // var reader = new FileReader();
                // reader.readAsDataURL(blob_);
                // reader.onloadend = function () {
                //     var base64String = reader.result;
                //     // console.log(base64String);
                //     setUrl(base64String);
                // };
                // const dataurl = URL.createObjectURL(blob_);
                // setDataUrl(dataurl);
            });
    }

    const getClassifyStructureTypeFileData = (params) => {
        //axios 開始前呼叫
        onBefore({
            axiosMode: "get",
        });
        return axios
            .get('/media_classification_storage/api/classify_structure_type/document', {
                params: params,
            })
            .then((response) => {
                let data = response.data;
                setData(data?.data);
                if (data) {
                    onFinish({
                        axiosMode: "get",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "get",
                        status: "error",
                    });
                }

                return {
                    ...data,
                };
            });
    };
    const patchClassifyStructureTypeFileData = (data) => {
        onBefore({
            axiosMode: "patch",
        });
        axios
            .patch(
                '/media_classification_storage/api/classify_structure_type_file',
                data
            )
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "success") {

                    onFinish({
                        axiosMode: "patch",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "patch",
                        status: "error",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "patch",
                    status: "error",
                });
            });
    };
    const patchDeleteClassifyStructureTypeFileData = (data) => {
        onBefore({
            axiosMode: "delete",
        });
        axios
            .patch(
                '/media_classification_storage/api/classify_structure_type_file_delete',
                data
            )
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "success") {

                    onFinish({
                        axiosMode: "delete",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "delete",
                        status: "error",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "delete",
                    status: "error",
                });
            });
    };
    const postClassifyStructureTypeFileData = (data) => {
        onBefore({
            axiosMode: "post",
        });
        axios
            .post('/media_classification_storage/api/classify_structure_type_file', data)
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "success") {
                    onFinish({
                        axiosMode: "post",
                        status: "success",

                    });
                } else {
                    onFinish({
                        axiosMode: "post",
                        status: "error",
                    });

                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "post",
                    status: "error",
                });
            });
    };
    const deleteClassifyStructureTypeFileData = (data) => {
        onBefore({
            axiosMode: "delete",
        });
        axios
            .delete(mainApi, {
                data,
            })
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "success") {
                    onFinish({
                        axiosMode: "delete",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "delete",
                        status: "error",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "delete",
                    status: "error",
                });
            });
    };

    const getClassifyStructureTypeFolderData = (params) => {
        //axios 開始前呼叫
        onBefore({
            axiosMode: "get",
        });
        return axios
            .get('/media_classification_storage/api/classify_structure_type/document', {
                params: params,
            })
            .then((response) => {
                let data = response.data;
                setData(data?.data);
                if (data) {
                    onFinish({
                        axiosMode: "get",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "get",
                        status: "error",
                    });
                }

                return {
                    ...data,
                };
            });
    };
    const postClassifyStructureTypeFolderData = (data) => {
        onBefore({
            axiosMode: "post",
        });
        axios
            .post(mainApi, data)
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "success") {
                    onFinish({
                        axiosMode: "post",
                        status: "success",

                    });
                } else {
                    onFinish({
                        axiosMode: "post",
                        status: "error",
                    });

                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "post",
                    status: "error",
                });
            });
    };
    const patchClassifyStructureTypeFolderData = (data) => {
        onBefore({
            axiosMode: "patch",
        });
        axios
            .patch(
                '/media_classification_storage/api/classify_structure_type_folder',

                data
            )
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "success") {

                    onFinish({
                        axiosMode: "patch",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "patch",
                        status: "error",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "patch",
                    status: "error",
                });
            });
    };
    const deleteClassifyStructureTypeFolderData = (data) => {
        onBefore({
            axiosMode: "delete",
        });
        axios
            .delete('/media_classification_storage/api/classify/type/folder', {
                data,
            })
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "success") {
                    onFinish({
                        axiosMode: "delete",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "delete",
                        status: "error",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "delete",
                    status: "error",
                });
            });
    };
    const getWord = (file_id) => {
        return axios
            .get("/media_classification_storage/api/file/docx", {
                params: { file_id: file_id },
            })
            .then((response) => {
                setContent(response.data?.content);
                return response.data?.content
            });
    };
    const editWord =(file_id ,content)=>{
        onBefore({
            axiosMode: "editWord",
        });
        axios
        .post("/media_classification_storage/api/file/docx", {
            content: content,
            file_id: file_id,
        })
        .then((response) => {
            let responseData = response.data;
            let status = responseData?.status;
            if (status === "success") {
                onFinish({
                    axiosMode: "editWord",
                    status: "success",

                });
            } else {
                onFinish({
                    axiosMode: "editWord",
                    status: "error",
                });

            }
        })
        .catch(() => {
            onFinish({
                axiosMode: "editWord",
                status: "error",
            });
        });
    }

    return {
        DocumentData: data,
        docxContent:content,
        getWord,
        editWord,
        getDocumentData,
        postDocumentData,
        patchDocumentData,
        downloadDocumentData,
        deleteDocumentData,
        getDocumentFile,
        // getClassifyStructureTypeFileData,
        patchClassifyStructureTypeFileData,
        postClassifyStructureTypeFileData,
        deleteClassifyStructureTypeFileData,
        patchDeleteClassifyStructureTypeFileData,
        // getClassifyStructureTypeFolderData,
        // postClassifyStructureTypeFolderData,
        patchClassifyStructureTypeFolderData,
        deleteClassifyStructureTypeFolderData
    };
};
export { useDocument };
